import { useEffect } from 'react';

import { useErrorHandler } from 'src/hooks';
import * as storage from 'src/lib/storage';
import {
  useBrandTermsActions,
  useCurrentWorkspaceId,
  useCustomerHasAccessToPerformance,
} from 'src/store';

export const RELOAD_BRAND_RULES_TOKEN_FIELD = 'postMaloneBrandRulesReload';

export const BrandRulesGuard = () => {
  const handleError = useErrorHandler();
  const brandTermsActions = useBrandTermsActions();
  const workspaceId = useCurrentWorkspaceId();
  const customerHasAccessToPerformance = useCustomerHasAccessToPerformance();

  useEffect(() => {
    const handler = async (event) => {
      if (event.key === RELOAD_BRAND_RULES_TOKEN_FIELD) {
        if (Number(event.newValue) === Number(true)) {
          if (!workspaceId || !customerHasAccessToPerformance) {
            return undefined;
          }

          try {
            await brandTermsActions.queryBrandTerms(workspaceId);
            storage.writeItem(RELOAD_BRAND_RULES_TOKEN_FIELD, Number(false));
          } catch (error) {
            handleError(error);
          }
        }
      }
    };

    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [brandTermsActions, customerHasAccessToPerformance, handleError, workspaceId]);

  return null;
};
